import React, { Suspense } from 'react';
import ReactRender from '../tools/react-render';

import './TagAutomation';
import './Product';

const databaseTable = document.querySelector('[data-behaviour="react-database-table"]');
if (databaseTable) {
    const DatabaseList = React.lazy(() => import('./Database/DatabaseList'));
    const databaseType = databaseTable.getAttribute('data-database');

    const DatabaseTableApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <DatabaseList type={databaseType} />
        </Suspense>
    );

    ReactRender(<DatabaseTableApp />, databaseTable);
}

const reactSearch = document.querySelector('[data-behaviour="react-adv-search"]');
if (reactSearch) {
    const SearchPage = React.lazy(() => import('./Search/Page/SearchPage'));
    const SearchPageApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <SearchPage />
        </Suspense>
    );

    ReactRender(<SearchPageApp />, document.querySelector('[data-behaviour="react-adv-search"]'));
}

const reactSearchOverlay = document.querySelector('[data-behaviour="react-search-overlay"]');
const reactSearchOverlayInput = document.querySelector('[data-behaviour="react-search-overlay-input"]');
if (reactSearchOverlay && reactSearchOverlayInput) {
    reactSearchOverlayInput.addEventListener('pointerenter', () => {
        const SearchOverlay = React.lazy(() => import('./Search/Overlay/SearchOverlay'));

        const SearchOverlayApp = () => (
            <Suspense fallback={(
                <form action="/?s" autoComplete="off" id="search" method="GET" className="search-form">
                    <input readOnly type="search" id="s" name="s" placeholder="Search e.g. keyword, product" value=""/>
                    <input readOnly type="hidden" id="type" name="type" value="post"/>
                    <i className="icon-search"></i>
                    <label htmlFor="s"></label>
                </form>
            )}>
                <SearchOverlay />
            </Suspense>
        );

        ReactRender(<SearchOverlayApp />, document.querySelector('[data-behaviour="react-search-overlay"]'));
    }, {once: true});
}

// const puzzlesEl = document.querySelector('[data-behaviour="react-puzzles"]');
// if (puzzlesEl) {
//     const Puzzles = React.lazy(() => import('./Puzzles'));
//     const PuzzlesApp = () => (
//         <Suspense fallback={<div>Loading...</div>}>
//             <Puzzles />
//         </Suspense>
//     );

//     ReactRender(<PuzzlesApp />, puzzlesEl);
// }

const issueCarouselEl = document.querySelector('[data-behaviour="issue-carousel"]');
if (issueCarouselEl) {
    const IssueCarousel = React.lazy(() => import('./IssueCarousel'));
    const pages = issueCarouselEl.getAttribute('data-pages');
    const issue = issueCarouselEl.getAttribute('data-issue');
    const count = issueCarouselEl.getAttribute('data-count');
    const start = issueCarouselEl.getAttribute('data-start-index');
    const path = issueCarouselEl.getAttribute('data-path');
    const paywall = JSON.parse(issueCarouselEl.getAttribute('data-paywall'));

    const IssueCarouselApp = () => (
        <Suspense fallback={<div className="issue-slider issue-slider--loading">
        <div className="issue-slider__list">
          {Array.from(
            { length: 6 },
            (_, i) => <div key={i} className="issue-slider__item"><div className="issue-slider__page"></div></div>
          )}
        </div>
      </div>}>
            <IssueCarousel pages={pages} issue={issue} count={count} start={start} paywall={paywall} path={path} />
        </Suspense>
    );

    ReactRender(<IssueCarouselApp />, issueCarouselEl);
}

const circuitsEl = document.querySelectorAll('[data-behaviour="react-circuits"]');
if (circuitsEl) {
    const Circuits = React.lazy(() => import('./Database/Circuits'));
    
    circuitsEl.forEach(circuit => {
        const circuitData = circuit.getAttribute('data-circuits');

        const CircuitsApp = () => (
            <Suspense fallback={<div></div>}>
                <Circuits data={circuitData} />
            </Suspense>
        );
    
        ReactRender(<CircuitsApp />, circuit);
    });
}
   
const imageLightboxEls = document.querySelectorAll('[data-behaviour="image-lightbox"]');
if (imageLightboxEls.length > 0) {
    imageLightboxEls.forEach(imageLightboxEl => {
        const ImageLightbox = React.lazy(() => import('./ImageLightbox'));
        const thumb = imageLightboxEl.getAttribute('data-thumb');
        const full = imageLightboxEl.getAttribute('data-full');
        const title = imageLightboxEl.getAttribute('data-title');

        const ImageLightboxApp = () => (
            <Suspense fallback={<div>Loading...</div>}>
                <ImageLightbox thumb={thumb} full={full} title={title} />
            </Suspense>
        );

        ReactRender(<ImageLightboxApp />, imageLightboxEl);
    });
}

const videoLightboxEls = document.querySelectorAll('[data-behaviour="video-lightbox"]');
if (videoLightboxEls.length > 0) {
    videoLightboxEls.forEach(videoLightboxEl => {
        const VideoLightbox = React.lazy(() => import('./VideoLightbox'));
        const video = videoLightboxEl.getAttribute('data-video');
        const thumb = videoLightboxEl.getAttribute('data-thumb');
        const portrait = videoLightboxEl.getAttribute('data-portrait');
        const width = videoLightboxEl.getAttribute('data-width');
        const height = videoLightboxEl.getAttribute('data-height');
        const title = videoLightboxEl.getAttribute('data-title');

        const VideoLightboxApp = () => (
            <Suspense fallback={<div>Loading...</div>}>
                <VideoLightbox video={video} thumb={thumb} portrait={portrait} width={width} height={height} title={title} />
            </Suspense>
        );

        ReactRender(<VideoLightboxApp />, videoLightboxEl);
    });
}
